import { capitalize } from '@/utils';

export const firstChar = (
  text?: string,
  textCase: 'UPPER' | 'LOWER' | 'DEFAULT' = 'UPPER',
) => {
  if (text) {
    const txt = text?.charAt(0);

    switch (textCase) {
      case 'UPPER':
        return txt.toUpperCase();
      case 'LOWER':
        return txt.toLowerCase();
      default:
        return txt;
    }
  }

  return '';
};

export const normalizePhoneNumber = (phone: string): string => {
  if (!phone) return phone;

  const trimmed = phone.trim();

  if (trimmed.startsWith('+88')) {
    return trimmed;
  }

  if (trimmed.startsWith('88')) {
    return `+${trimmed}`;
  }

  return `+88${trimmed}`;
};

export type SelectOption = {
  value: number;
  label: string;
};

export const createNumberOptions = (
  start: number,
  end: number,
  suffix = 'Day',
): SelectOption[] => {
  return Array.from({ length: end - start + 1 }, (_, i) => {
    const value = start + i;
    return {
      value,
      label: `${value} ${suffix}${value > 1 && suffix ? 's' : ''}`,
    };
  });
};

export const formatToSnakeCase = (text: string) => {
  return text
    ?.split(' ')
    ?.map((word) => word.toLowerCase())
    .join('_');
};

export const snakeToCamel = (text: string) => {
  return capitalize(text?.split('_').join(' '));
};
export function addHttps(url: string) {
  if (!url) return url;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  return 'https://' + url;
}
